module.exports = __webpack_public_path__ + "img/add-user.cd74a1a0.png";